import { ref } from 'vue'
import { defineStore } from 'pinia'
import { useConfigStore } from '@/stores/config'
import { useRequestsStore } from '@/stores/requests'
import { useTokenStore } from '@/stores/token'

export const useCmdStore = defineStore('cmd', () => {

    const configStore   = useConfigStore()
    const requestsStore = useRequestsStore()
    const tokenStore    = useTokenStore()

    /**
     * Отправка встроенных комманд на сервер для пересылки на устойство
     * Если устройство не на связи - возвратит ошибку
     * 
     * @param {Object} payload - команда (см.swagger)
     */
    async function executeCmd(payload) {

        const token = tokenStore.access
        let result = {}

        if(payload.cmd && payload.cmd == 'Reboot') 
            rebootGnssProcess.value = true

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/command/execute`, 
                method: 'POST', 
                token,
                data: payload
            })

            result = request

            if(!request.error) {
                executeCmdMsg.value = { success: true, text: 'CMD_SUCCESS' } 
            } else {
                executeCmdMsg.value = { success: false, text: request.error }
            }

        } else {
            executeCmdMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        if(payload.cmd && payload.cmd == 'Reboot') 
            rebootGnssProcess.value = false

        return result
    }

    /**
     * Отправка комманд на сервер для пересылки на устойство
     * Если устройство не на связи - возвратит ошибку
     * 
     * @param {Object} payload - { type: "тип_команды", payload: { см.swagger } }
     */
    async function sendCmd(payload) {

        switch(payload.type) {
            case 'test': testCmdProcess.value = true
                break 
            case 'server': changeDataServerProcess.value = true
                break 
        }

        const token = tokenStore.access

        if(token) {

            const request = await requestsStore.fetchRequest({
                address: `${configStore.httpServer}/devices/command/send`, 
                method: 'POST', 
                token,
                data: payload.data
            })

            if(!request.error) {

                let status,
                    text

                switch(request.status) {

                    case 'NOT_SET': 
                        status = false, 
                        text = 'CMD_RESULT_NOT_SET'
                        break

                    case 'SEND_IN_PROCESS': 
                        status = true, 
                        text = 'CMD_RESULT_SEND_IN_PROCESS'
                        break

                    case 'SEND_TIMEOUT': 
                        status = false, 
                        text = 'CMD_RESULT_SEND_TIMEOUT'
                        break

                    case 'SEND_CONFIRMED': 
                        status = false, 
                        text = 'CMD_RESULT_SEND_CONFIRMED'
                        break

                    case 'RESULT_OK': 
                        status = true, 
                        text = 'CMD_RESULT_RESULT_OK'
                        break

                    case 'RESULT_ERROR': 
                        status = false, 
                        text = 'CMD_RESULT_RESULT_ERROR'
                        break

                    case 'RESULT_ILL': 
                        status = false, 
                        text = 'CMD_RESULT_RESULT_ILL'
                        break

                    case 'RESULT_DEL': 
                        status = true, 
                        text = 'CMD_RESULT_RESULT_DEL'
                        break

                    case 'RESULT_NOT_FOUND': 
                        status = false, 
                        text = 'CMD_RESULT_RESULT_NOT_FOUND'
                        break

                    case 'RESULT_NOT_CONFIG': 
                        status = true, 
                        text = 'CMD_RESULT_RESULT_NOT_CONFIG'
                        break

                    case 'RESULT_IN_PROCESS': 
                        status = true, 
                        text = 'CMD_RESULT_RESULT_IN_PROCESS'
                        break

                    default: 
                        status = false, 
                        text = 'CMD_RESULT_UNDEFFINED'
                        break
                }
                sendCmdMsg.value = { success: status, text: text } 

            } else {
                sendCmdMsg.value = { success: false, text: request.error }
            }
            
        } else {
            sendCmdMsg.value = { success: false, text: 'EUnauthRequest' }
        }

        switch(payload.type) {

            case 'test': testCmdProcess.value = false
                break 

            case 'server': changeDataServerProcess.value = false
                break 
        }
    }

    const executeCmdProcess         = ref(false)
    const executeCmdMsg             = ref({})
    const sendCmdProcess            = ref(false)
    const sendCmdMsg                = ref({})
    const rebootGnssProcess          = ref(false)
    const testCmdProcess            = ref(false)
    const changeDataServerProcess   = ref(false)

    const setExecuteCmdMsg  = data => executeCmdMsg.value   = data
    const setSendCmdMsg     = data => sendCmdMsg.value      = data

    return {

        executeCmdProcess,
        executeCmdMsg,
        sendCmdProcess,
        sendCmdMsg,
        rebootGnssProcess,
        testCmdProcess,
        changeDataServerProcess,
        executeCmd,
        sendCmd,
        setExecuteCmdMsg,
        setSendCmdMsg
    }
})
